export default __webpack_public_path__ + "static/media/Wall_Window_8x4_01.256.65f51189.png";